import { call, put } from 'redux-saga/effects';
import { onUpdateVehicleDataFailure, onUpdateVehicleDataSuccess } from '../actions';
import { VehicleService } from '../services';
/**
 * Saga to handle the request to update job vehicle
 * @param action
 * @param vehicleService
 */
export function* updateJobVehicleSaga(action, 
/*istanbul ignore next*/
vehicleService = VehicleService.getInstance(), storage = sessionStorage) {
    try {
        yield call({
            fn: vehicleService.UpdateJobVehicleData,
            context: vehicleService
        }, action.payload.jobId, action.payload.jobVehicleData, action.payload.companyDefinedFieldsRequestPayload);
        //success action to notify store
        yield put(onUpdateVehicleDataSuccess());
        const returnUrl = storage.getItem('returnUrl');
        if (returnUrl && action.payload.shouldRedirectToReturnUrl) {
            storage.removeItem('returnUrl');
            window.location.assign(returnUrl);
        }
    }
    catch (exception) {
        yield put(onUpdateVehicleDataFailure(exception.toString()));
    }
}
//# sourceMappingURL=updateJobVehicleSaga.js.map